import { Moon, Sun } from 'lucide-react';
import { useTheme } from "../hooks/useTheme"; // Importamos nuestro nuevo hook
import { ActionButton } from "./Navbar"; // Importamos el botón consistente

export default function ToggleDarkMode() {
  // 🔥 ¡Toda la lógica compleja se reduce a esta línea!
  const { theme, setTheme } = useTheme();
  
  // La función toggle ahora es mucho más clara.
  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  const isDark = theme === 'dark';

  return (
    // 🔥 Usamos el ActionButton para consistencia visual total.
    <ActionButton 
      onClick={toggleTheme}
      title={isDark ? "Activar modo claro" : "Activar modo oscuro"}
    >
      {isDark ? (
        <Sun className="h-6 w-6 text-yellow-400" />
      ) : (
        <Moon className="h-6 w-6 text-blue-300" />
      )}
    </ActionButton>
  );
}